import React, { useState, useRef, useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import SearchIcon from 'assets/images/search-icon.png';
import { SearchContainer } from "./typeahead";
import './typeahead.js';

const InvoiceSearchTypeahead = ({
  placeholder,
  minLength,
  asyncSearch,
  searchUrl,
  filterBy,
  pageType,
  toggle,
  defaulTitle,
  title,
  pageName,
  transparent,
  focusOnShow,
  searchHandler,
  background,
  color,

  callBack
}) => {
  const ref = useRef();

  const [options, setOptions] = useState([]);
  let defaultTxt = defaulTitle;
  const [defaultState, setDefaultState] = useState(defaultTxt);

  useEffect(() => {
    if (focusOnShow) {
      ref.current.focus();
    }
    if (defaultTxt === '') ref.current.clear();
    setDefaultState(defaultTxt)
  }, [defaultTxt]);


  const [searchResponse, setSearchResponse] = useState({ payload: [], title: '', totalRecods: '' });
  const handleSearch = async (query) => {
    callBack(query)
    setSearchResponse(query)
  };


  return (
    asyncSearch && (
      <SearchContainer>
        <div
          className={`type-ahead-search-input ${transparent ? "search-input-transparent" : ""
            }`}
        >
          <AsyncTypeahead
            ref={ref}
            multiple={false}
            id={Math.random().toString()}
            labelKey="title"
            filterBy={["locationName", "invoiceNumber"]}
            isLoading={false}
            minLength={minLength}
            onSearch={handleSearch}
            options={options}
            placeholder={placeholder}
            defaultInputValue={defaultState || ""}
            onInputChange={(text) => {
              setDefaultState(text);
              handleSearch(text);
            }}
            onKeyDown={(event) => {
            }}
            onChange={(event) => {
              if (event.length !== 0 && event[0].locationName) {
                handleSearch(event[0].locationName.toString());
                setDefaultState(event[0].locationName);

              }
              _.isFunction(toggle) && toggle();
            }}
            renderMenuItemChildren={(option) => <span>{option[filterBy]}</span>}
          />

          {/* <div
            className="seacrh-icon"
            onClick={(event) => {
              if (searchResponse.locationName) {
                handleSearch(searchResponse.locationName.toString());
                setDefaultState(searchResponse.locationName.toString());            
              }
            }}
          >
            <img src={SearchIcon} alt="SearchIcon" />
          </div> */}
        </div>
      </SearchContainer>
    )
  );
};

InvoiceSearchTypeahead.propTypes = {
  placeholder: PropTypes.string,
  minLength: PropTypes.number,
  asyncSearch: PropTypes.bool,
  searchUrl: PropTypes.string,
  focusOnShow: PropTypes.bool,
  background: PropTypes.string,
  color: PropTypes.string,
};

InvoiceSearchTypeahead.defaultProps = {
  placeholder: '',
  minLength: 1,
  asyncSearch: true,
  /**
   * @todo : SearchUrl and filterBy should be empty, this needs to be refactored after search api integration
   */
  searchUrl: 'https://api.github.com/search/users',
  filterBy: 'login',
  transparent: false,
  focusOnShow: true,
};

export default InvoiceSearchTypeahead;
